export const MINIMUM_APPOINTMENT_PRICE = 50;
